import * as _ from 'lodash';
import { useState } from 'react';
import { IDonor, IMatchRunSwap, ISortBy } from '@nkr/models/index';
import { FormControl, Glyphicon } from 'react-bootstrap';
import { ChainTableWrapper } from './styles';

interface IProps {
    swaps: IMatchRunSwap[],
    deepestChainDepth: number,
    donors: IDonor[]
}

const ChainStarterList = (props: IProps) => {
    const [depth, setDepth] = useState(-1);
    const [sortBy, setSortBy] = useState<ISortBy[]>([{ property: 'index', direction: 'asc' }]);

    const handleSortChanged = (field: string) => {
        let f = sortBy.find(x => x.property == field);

        if (f != null) {
            f.direction = f.direction == 'asc' ? 'desc' : '';
        } else {
            f = {
                property: field,
                direction: 'asc'
            };
        }

        if (f.direction == '') {
            f = null;
        }

        if (f != null) {
            setSortBy([f]);
        } else {
            setSortBy([]);
        }
    };

    const chainDepths = _.range(0, props.deepestChainDepth + 1).map(cd => {
        return { value: cd, label: cd + ' (' + props.swaps.filter(x => x.depth == cd).length + ')' };
    });

    const hydrateData = (): { swapsWithIndexCount: number, swaps: { index: number, swap: IMatchRunSwap }[] } => {
        let swapsWithIndex = props.swaps.map((swap, index) => ({ index, swap }));

        let swaps = (depth >= 0 ? swapsWithIndex.filter(x => x.swap.depth == depth) : (depth == -2 ? swapsWithIndex : swapsWithIndex.filter(x => x.swap.depth > 0))).map(x => {
            x.swap.donor = props.donors.find(d => d.id == x.swap.chainStart);
            return x;
        });

        return { swapsWithIndexCount: swapsWithIndex.length, swaps };
    };

    const renderSortIndicator = (field: string) => {
        let f = sortBy.find(x => x.property == field);

        if (f != null) {
            let fIndex = sortBy.findIndex(x => x.property == f.property);

            if (sortBy.length > 1) {
                return <><Glyphicon glyph={f.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} /><span style={{ fontSize: 10 }}>({fIndex + 1})</span></>;
            } else {
                return <Glyphicon glyph={f.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} />;
            }
        }

        return null;
    };

    const { swapsWithIndexCount, swaps } = hydrateData();

    const sortedData = sortBy.length > 0 ? _.orderBy(swaps, [item => {
        if (sortBy.length > 0) {
            let property = sortBy[0].property;

            if (property == 'index') {
                return item.index;
            }

            if (property == 'chainStartCenter') {
                return item.swap.donor.center.alias;
            }

            if (property == 'chainStartAlias') {
                return item.swap.donor.alias;
            }

            if (property == 'depth') {
                return item.swap.depth;
            }
        }

        return '';
    }], [sortBy[0].direction]) : swaps;

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 5 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5, fontSize: 12 }}>Depth:</div>
                    <FormControl
                        componentClass='select'
                        style={{ height: 'initial', padding: '3px 6px', fontSize: 12 }}
                        value={depth}
                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setDepth(parseInt(e.currentTarget.value))}
                    >
                        <option value={-2}>- All Depths -</option>
                        <option value={-1}>&gt; 0</option>
                        {chainDepths.map(cd =>
                            <option key={'cd-' + cd.value} value={cd.value}>{cd.label}</option>
                        )}
                    </FormControl>
                </div>
            </div>

            <ChainTableWrapper condensed bordered striped>
                <thead>
                    <tr>
                        <th onClick={() => handleSortChanged('index')}>Swap Index {renderSortIndicator('index')}</th>
                        <th onClick={() => handleSortChanged('chainStartCenter')}>Chain Start Center {renderSortIndicator('chainStartCenter')}</th>
                        <th onClick={() => handleSortChanged('chainStartAlias')}>Chain Start Alias  {renderSortIndicator('chainStartAlias')}</th>
                        <th onClick={() => handleSortChanged('depth')}>Depth {renderSortIndicator('depth')}</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((item, index) =>
                        <tr key={'cs-' + index}>
                            <td>{item.index}</td>
                            <td>{item.swap.donor.center.alias}</td>
                            <td>{item.swap.donor.alias}</td>
                            <td>{item.swap.depth}</td>
                        </tr>
                    )}
                </tbody>
            </ChainTableWrapper>

            <div style={{ fontSize: 12 }}>{swaps.length} of {swapsWithIndexCount} chain starters...</div>
        </>
    );
}

export default ChainStarterList;